function Table({ name, children }) {
  return (
    <table
      id={name}
      className="table-fixed overflow-y-auto flex-nowrap min-w-full divide-y-2 divide-amber-200"
    >
      {children}
    </table>
  );
}

export default Table;
